/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Install_TitleInputs */

const en_wc_dl_install_title = /** @type {(inputs: Wc_Dl_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to install`)
};

/**
* | output |
* | --- |
* | "How to install" |
*
* @param {Wc_Dl_Install_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_install_title = /** @type {((inputs?: Wc_Dl_Install_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Install_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_install_title(inputs)
});
export { wc_dl_install_title as "wc.dl.install_title" }